var exports = {
  "kL": "GuildInvitesTab.module__container___Q2xKR2",
  "wx": "GuildInvitesTab.module__header___Q2xKR2",
  "DD": "GuildInvitesTab.module__title___Q2xKR2",
  "VA": "GuildInvitesTab.module__subtitle___Q2xKR2",
  "dc": "GuildInvitesTab.module__spinnerContainer___Q2xKR2",
  "sJ": "GuildInvitesTab.module__invitesContainer___Q2xKR2",
  "IH": "GuildInvitesTab.module__inviteList___Q2xKR2",
  "eu": "GuildInvitesTab.module__inviteItems___Q2xKR2",
};

module.exports = exports;
